import {Dialog, DialogContent} from '@mui/material';
import ManualTask from './ManualTask';

type Props = {
  open: boolean;
  setOpen: (val: boolean) => void;
  id: number;
};
const ManualTaskViewDialog = ({open, setOpen, id}: Props) => {
  return (
    <Dialog
      open={open}
      sx={{
        '& .MuiPaper-root': {background: `var(--blue-variant17) !important`},
      }}
      maxWidth='md'
      fullWidth
      oaria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'>
      <DialogContent className='p-0'>
        <ManualTask setOpen={setOpen} id={id} />
      </DialogContent>
    </Dialog>
  );
};

export default ManualTaskViewDialog;
